import { EXPORT_TRANSLATE_IMPROVEMENTS_QUERY } from './useExportTranslateImprovements.graphql';
import {
  IExportTranslateImprovementsQueryGraphQLResponse,
  IExportTranslateImprovementsQueryVariables,
  IHandleExportTranslateImprovementsParams,
  IUseExportTranslateImprovements,
  IUseExportTranslateImprovementsOptions,
} from './useExportTranslateImprovements.interfaces';

import { useKanziLazyQuery } from '../../apollo';

const useExportTranslateImprovements = (options?: IUseExportTranslateImprovementsOptions): IUseExportTranslateImprovements => {
  const { fetchPolicy, onCompleted, onError, query, token } = options ?? ({} as IUseExportTranslateImprovementsOptions);

  const [executeExportTranslateImprovements, { loading: isLoading }] = useKanziLazyQuery<
    IExportTranslateImprovementsQueryGraphQLResponse,
    IExportTranslateImprovementsQueryVariables
  >({
    options: {
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          translateImprovement: { exportTranslateImprovements: asset },
        } = data;

        onCompleted({
          asset,
        });
      },
      onError,
    },
    query: query ?? EXPORT_TRANSLATE_IMPROVEMENTS_QUERY,
    token,
  });

  const handleExportTranslateImprovements = ({
    end,
    ianaTimeZone,
    language,
    projectId,
    start,
    status,
  }: IHandleExportTranslateImprovementsParams) => {
    executeExportTranslateImprovements({
      variables: {
        end,
        ianaTimeZone,
        language,
        projectId,
        start,
        status,
      },
    });
  };

  return {
    handleExportTranslateImprovements,
    isLoading,
  };
};

export { useExportTranslateImprovements };
